export type VariationStatusMessages = {
  notFoundError: string;
  notFoundDescription: string;
  updateSuccess: string;
  updateError: string;
  createSuccess: string;
  createError: string;
  errorToLoad: string;
  notFoundAlt: string;
};

export const VARIATION_STATUS_MESSAGES: VariationStatusMessages = {
  notFoundError: "Variação de produto não encontrada",
  notFoundDescription: "Não conseguimos encontrar a variação de produto que você está procurando",
  updateSuccess: "Variação de produto atualizada com sucesso!",
  updateError: "Erro ao salvar a variação do produto!",
  createSuccess: "Variação de produto criada com sucesso!",
  createError: "Erro na criação da variação do produto!",
  errorToLoad: "Erro ao carregar variação do produto",
  notFoundAlt: "Imagem da variação do produto não encontrada",
};

export default VARIATION_STATUS_MESSAGES;
